export default "__VITE_ASSET__ykK7Ve83__"